import { useRef } from 'react'

import { usePage } from '@/components/providers/PageProvider'
import { useFiltersFocus } from '@/hooks/useFiltersFocus'
import { unslugify } from '@/utils/commonUtil'

import { FilterInputTypeahead } from '../FilterInputTypeahead/FilterInputTypeahead'

import { FilterInputTagPopular } from './FilterInputTagPopular/FilterInputTagPopular'

type Props = {
  variant?: 'popular'
}

export const FilterInputTag = ({ variant }: Props) => {
  const { page } = usePage()
  const refInput = useRef<HTMLInputElement>(null)

  const isFocusRequested = useFiltersFocus('tags', () => refInput.current?.focus())

  const route = page?.route
  const tags = page?.optionsFilters?.tags

  const tagSelected = route?.tagSlug
    ? tags?.find((filterOption) => filterOption.slug === route.tagSlug) || {
        count: 0,
        label: unslugify(route.tagSlug),
        slug: route.tagSlug,
      }
    : undefined

  if (tags === undefined) return null

  if (variant === 'popular') return <FilterInputTagPopular tagSelected={tagSelected} tags={tags} />

  return (
    <FilterInputTypeahead
      autoFocus={isFocusRequested}
      filter='tagSlug'
      label='Tags'
      optionSelected={tagSelected}
      options={tags}
      ref={refInput}
      showCheckboxes={false}
    />
  )
}
